import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { Button, Icon, Segment, List, Header } from "semantic-ui-react";
import { Link } from "react-router-dom";
import User from "~/models/User";
import AuthenticatedUserHelper from "~/utils/AuthenticatedUserHelper";

const VideoDownload = observer(
  ({ tourId, editDisabled, exportedTourVideoBrandedUrl, exportedTourVideoUnbrandedUrl, user, t }) => (
    <Segment>
      <Header as="h3" id="video-download">
        {t("clientPanelDownload:videoTour")}
        {!editDisabled && AuthenticatedUserHelper.isAuthenticatedCustomer(user) && (
          <Header.Subheader>
            <Link to={`/tours/${tourId}/video-request`}>{t("clientPanelDownload:editVideo")}</Link>
          </Header.Subheader>
        )}
      </Header>
      <List horizontal>
        {exportedTourVideoBrandedUrl && (
          <List.Item>
            <Button href={exportedTourVideoBrandedUrl} primary target="_blank">
              <Icon name="download" />
              &nbsp;{t("clientPanelDownload:downloadBrandedVideo")}
            </Button>
          </List.Item>
        )}
        {exportedTourVideoUnbrandedUrl && (
          <List.Item>
            <Button href={exportedTourVideoUnbrandedUrl} primary target="_blank">
              <Icon name="download" />
              &nbsp;{t("clientPanelDownload:downloadUnbrandedVideo")}
            </Button>
          </List.Item>
        )}
        {!(exportedTourVideoBrandedUrl || exportedTourVideoUnbrandedUrl) && (
          <List.Item>
            <p>{t("clientPanelDownload:noVideoGeneratedForTour")}</p>
          </List.Item>
        )}
      </List>
    </Segment>
  ),
);

VideoDownload.propTypes = {
  tourId: PropTypes.number.isRequired,
  exportedTourVideoUnbrandedUrl: PropTypes.string,
  exportedTourVideoBrandedUrl: PropTypes.string,
  editDisabled: PropTypes.bool,
  user: PropTypes.instanceOf(User),
  t: PropTypes.func.isRequired,
};

VideoDownload.defaultProps = {
  editDisabled: false,
};

export default withTranslation()(VideoDownload);
